import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Resolve
} from "@angular/router";
import { HttpService } from "./../../modules/http-with-injector/http.service";
import { isJson } from "./../../globals/_classes/functions";
import { DomSanitizer } from "@angular/platform-browser";
import { PLATFORM_ID,Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CookieService } from 'ngx-cookie';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: "root"
})
export class ContentResoveService implements Resolve<any> {
  favIconUrl = "assets/img/admin/logo/favicon.png";

  constructor(@Inject(PLATFORM_ID) private platform: Object,@Inject(DOCUMENT) private document: any,private cookieService: CookieService,private sanitizer: DomSanitizer, private http: HttpService) {}
  resolve(router: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // set currency to localStroge
    //if (isPlatformBrowser(this.platform)) {
    this.http
      .get("currency-config")
      .toPromise()
      .then(res => {
        const currency = res.result.data;
        if (currency) {
          //this.cookieService.put("currency", JSON.stringify(currency));
          this.document.currency = JSON.stringify(currency)
        }
        if(isPlatformBrowser(this.platform)){
          localStorage.setItem("currency",JSON.stringify(currency))
        }
      });

    return this.http
      .get("contents")
      .toPromise()
      .then(res => {
        // console.log(res);
        if (res.status === "OK" && res.result.data.length > 0) {
          const content = {};
          const data = res.result.data.filter(f => {
            return f["config"].status === 1;
          });

          for (const c of data) {
            const tag = this.formatTag(c.config.tag);
            content[tag] = isJson(c.contents)
              ? JSON.parse(c.contents)
              : c.contents;
          }
          //this.cookieService.put("contents", JSON.stringify(content));
          if(isPlatformBrowser){
            localStorage.setItem("contents", JSON.stringify(content));
          }
          this.document.contents = JSON.stringify(content);
          // console.log("________________",this.document)

          //set favIcon
          let icon = content["site_specific"]["general"]["favicon"];
          if (icon == "" || icon == null || icon == "https://via.placeholder.com/60") {
            this.favIconUrl = "assets/img/admin/logo/favicon.png";
          } else {
            this.favIconUrl = icon;
          }

          this.setAppFavicon("favIcon", this.favIconUrl);

          return content;
        } else {
          return {};
        }
      })
      .catch(err => console.log(err));
    //}
  }

  formatTag(text: String) {
    return text.replace(/(\-[a-z])/g, function($1) {
      return $1.toUpperCase().replace("-", "");
    });
  }

  get contents() {
    if (isPlatformBrowser(this.platform)) {
    const contents = new Object();
    const con = localStorage.getItem("contents")
      ? JSON.parse(localStorage.getItem("contents"))
      : null;
    return con;
    }else{
      const contents = new Object();
      // console.log("contents",this.document.contents)
    const con = this.document.contents
      ? JSON.parse(this.document.contents)
      : null;
    return con;
    }
  }

  setAppFavicon(id: string, path: string) {
    if (isPlatformBrowser(this.platform)) {
    $("#" + id + "1").attr("href", path);
    $("#" + id + "2").attr("href", path);
    }
  }
}
